















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString, getMainCurrencyCode } from "@/lib/moneyHelpers";
import { UploadVaultFile } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import CustomScroll from "@/components/CustomScroll";

export default defineComponent({
  name: "VaultFileCaption",
  components: { CustomScroll, BaseIconButton },
  props: {
    file: { type: Object as PropType<UploadVaultFile>, required: true },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, default: () => [] },
  },
  setup(props) {
    const price = computed(() => {
      if (props.file.pricePackageId === null) return $t("No price");
      const amount = props.paymentPackages.find(item => item.id === props.file.pricePackageId)?.costs[0].cost;
      return formatMoneyString(amount ?? 0, { currencyCode: getMainCurrencyCode() });
    });

    return { price };
  },
});
